import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { ModalService } from 'src/app/services/modal-service.service';
import { DataService } from 'src/app/services/data.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Icons } from '../components/modal-alert/enums';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private dataService: DataService,
    private modalService: ModalService,
    private dialog: MatDialog,
    private router: Router
  ) { }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap({
        next: () => null,
        error: async (err: any) => {

          const msg = err.error.userError || 'Ha ocurrido un error desconocido';
          const info = err.error.info !== undefined ? err.error.info : '';

          switch (err.status) {
            case 400:
              this.validateIncludesPath(request, 'buro/nip') ? this.openAlert(msg, true, 'boton-error-validanip') : this.openAlert(msg, false);
              break;
            case 401:
              this.dataService.setIsLoged(false);
              this.dataService.setIdKeycloak('');
              this.dialog.closeAll();
              const result = await this.modalService.openAlertNotLogged();
              return result ? this.router.navigate(['/profile']) : this.router.navigate(['/home']);
            case 404:

              if (!this.validateIncludesPath(request, 'images-car?uid_jato') && msg !== 'El precio del auto tuvo un cambio' && !this.checkErrorBitly(err)) {
                if (this.validateIncludesPath(request, 'validateCode')) {
                  this.openAlert(info, true, undefined, msg);
                } else {
                  this.openAlert(msg, false);
                }
              }

              break;
            case 500:
              if (this.validateIncludesPath(request, 'specs-car?uid_jato') || this.validateIncludesPath(request, 'images-car?uid_jato') || this.validateIncludesPath(request, 'services-plus') || this.validateIncludesPath(request, 'compare-insurance') || this.validateIncludesPath(request, 'refresh')) {
                if (!this.validateIncludesPath(request, 'refresh')) {
                  console.error(err);
                }
                break;
              }
              this.openAlert(msg, false);
              break;
            case 502:
              //TODO: Error de gateway - Documentos - validar respuesta
              console.log(err);
              break;

            default:
              this.openAlert(msg, false);
              break;
          }
          return '';
        },
      })
    );
  }



  async openAlert(msg: string, withId: boolean, id?: string, title = '') {
    if (withId) {
      await this.modalService.showAlertWithIds(msg, Icons.error, id!, '', false, title);
    } else {
      await this.modalService.showAlertWithoutIds(msg, Icons.error, false, title);
    }

  }


  validateIncludesPath(request: HttpRequest<unknown>, url: string): boolean {
    return request.url.includes(url) ? true : false;

  }

  checkErrorBitly(error: any) {
    return (
      error.url.includes('bitly') &&
      error.error?.message === 'MONTHLY_ENCODE_LIMIT_REACHED'
    );
  }
}
